module.exports = __webpack_public_path__ + "static/media/meiski.f2df87db.png";